<template>
    <customModal :containermd="true" @closeModal="$emit('close')">
        <template #title>
            Subject Summary
        </template>

        <template #body>
            <div class="modal-scroll-body">

                <!-- Loader -->
                <div v-if="loading" class="d-flex justify-content-center align-items-center py-5">
                    <div class="spinner-border text-primary" role="status"></div>
                </div>

                <div v-else>

                    <!-- Table -->
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Site Code</th>
                                    <th>Subject ID</th>
                                    <th>Screening Date</th>
                                    <th>Enrollment Date</th>
                                    <th>Withdrawal Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="p in patients" :key="p.id">
                                    <td>{{ p.siteCode }}</td>
                                    <td>{{ p.subjectId }}</td>
                                    <td>{{ formatDate(p.screeningDate) }}</td>
                                    <td>{{ formatDate(p.enrollmentDate) }}</td>
                                    <td>{{ formatDate(p.withdrawalDate) }}</td>
                                    <td>{{ p.status }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row mx-0 mt-2" v-if="totalPages > 1">
                            <div class="col-lg-12 px-0">
                                <div class="d-flex justify-content-end">
                                    <VPagination v-model="currentPage" :pages="totalPages" :range-size="1"
                                        active-color="#618bd7" @update:modelValue="loadPage" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>
    </customModal>
</template>
<script src="./SubjectSafetyModal.js"></script>